export default __webpack_public_path__ + "static/media/projects-icon-red.f3f3cd26.svg";